@if (selectedLaboratory()) {
  <div id="title--container">
    <h4>Add New Device</h4>
    <h5>{{ selectedLaboratory()?.laboratoryName }}</h5>
  </div>
  <hr aria-hidden="true" />
  <div id="new-device--container">
    <div id="instructions--container">
      <div class="header">
        <div class="card-title">Register a new device to {{ selectedLaboratory()?.laboratoryName ?? 'lab' }}</div>
      </div>
      <hr class="card-divider" aria-hidden="true" />
      <div id="instructions">
        <div class="card-subtitle">Before you begin</div>
        <ol type="1">
          <li>Turn on the device.</li>
          <li>
            Connect the device to your Wi-Fi network. This can be done through
            the device menus <span class="highlighted subtitle2">Wi-Fi -> Network connect</span>, where it will present any
            available Wi-Fi networks. A network can then be selected, and the
            details entered.

            <span class="highlighted note">Note: Before entering the details for a network, you will
            need to enter the number of characters you will be inputting for the
            details.</span>
          </li>
          <li class="three">
            Create a name to easily identify your device and type it into the
            <span class="highlighted subtitle2">Name</span> box.
          </li>
          <li>
            Find the MAC Address of the device. The MAC Address can be found via
            <span class="highlighted subtitle2">Wi-Fi -> MAC Address</span>, where you can then type it into the box below.
            Then click <span class="highlighted subtitle2">Add Device</span>.
          </li>
          <li>
            Once the device has been successfully added to the system, please
            restart it (power off and back on) to trigger a sync with the app.
          </li>
        </ol>
      </div>
    </div>
    <div id="form--container">
      <div class="header">
        <div class="card-title">Device Details</div>
      </div>
      <hr class="card-divider" aria-hidden="true" />
      <form [formGroup]="createDeviceForm" (ngSubmit)="addDevice()">
        <div class="fields">
        <app-underlined-form-field
          [parentForm]="createDeviceForm"
          [field]="nameField"
        ></app-underlined-form-field>
        <app-underlined-form-field
          id="field-with-tooltip"
          [parentForm]="createDeviceForm"
          [field]="macAddressField"
          [useMacAddressFormat]="true"
          tooltipText="Valid MAC addresses contain 12 hexadecimal characters (0–9, A–F) formatted as 6 pairs separated by colons (e.g. AA:BB:CC:DD:EE:FF). Invalid characters can’t be typed in this field."
        ></app-underlined-form-field>
        </div>
        <div id="button--container">
          <app-icon-button
            label="add device"
            buttonId="add-device-btn"
            buttonShape="square"
            buttonType="submit"
            iconName="add"
            [isDisabled]="createDeviceForm.invalid"
            [isProcessing]="isProcessing()"
          ></app-icon-button>
        </div>
      </form>
    </div>
  </div>
} @else {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
}
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error()?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
